import api from "../../api";
import { getTerminalsByUserEndpoint } from "../../api/apisUrl";
import { apiError } from "../../models";
import {
  GET_USERS_TERMINALS_FAILD,
  GET_USERS_TERMINALS_LOADING,
  GET_USERS_TERMINALS_SUCCESS,
} from "../types";

export const getTerminalsByUserId = (token: any, id: any) => {
  return async (
    dispatch: (arg0: {
      type: string;
      loading?: boolean;
      payload?: any;
      error?: any;
    }) => void
  ) => {
    dispatch({ type: GET_USERS_TERMINALS_LOADING, loading: true });
    await api
      .get(getTerminalsByUserEndpoint(id), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        dispatch({ type: GET_USERS_TERMINALS_LOADING, loading: false });
        dispatch({ type: GET_USERS_TERMINALS_SUCCESS, payload: res.data });
      })
      .catch((err) => {
        apiError(
          GET_USERS_TERMINALS_LOADING,
          GET_USERS_TERMINALS_FAILD,
          err,
          dispatch
        );
      });
  };
};
